import type { TrackerFetcher } from '@/provider/TrackerProvider.types'
import { apiFetch } from './api'
import type { SubmitRunInput } from './queries.types'
import type { SubmitRunResult } from './types'

export async function submitRun(
  fetcher: TrackerFetcher,
  input: SubmitRunInput
): Promise<SubmitRunResult> {
  const result = await apiFetch<SubmitRunResult>(fetcher, '/api/run', {
    method: 'POST',
    body: { mode: 'direct', ...input },
  })

  if (!result) throw new Error('Run submission returned an empty response')

  return result
}
